<template>
  <el-dialog v-loading="loading" title="相似患儿列表" :visible.sync="isShow" @close='closeDetail' width="70%">
    <div class="dialog-content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column width="150" prop="childName" label="患儿姓名">
        </el-table-column>
        <el-table-column width="150" prop="sexText" label="性别">
        </el-table-column>
        <el-table-column width="150" prop="nationText" label="民族">
        </el-table-column>
        <el-table-column width="200"  prop="nationText" label="户口所在地">
          <template slot-scope="scope">
            <TableCellWordBreak :content="scope.row.provinceText + scope.row.cityText"></TableCellWordBreak>
          </template>
        </el-table-column>


        <el-table-column prop="hospitalName"   label="救助医院">
          <template slot-scope="scope">
            <TableCellWordBreak :content="scope.row.hospitalNameSet"></TableCellWordBreak>
          </template>
        </el-table-column>
        <el-table-column prop="birth"  label="病种">
          <template slot-scope="scope">

            <TableCellWordBreak :content="scope.row.diseasesNameSet"></TableCellWordBreak>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </el-dialog>
</template>

<script>
  import {getNotMergedSimilarChildList} from "../../../util/api";
  import TableCellWordBreak from "@/components/business/TableCellWordBreak"
  export default {
    name: "moneyInput",
    components: {
      TableCellWordBreak
    },
    props: {
      dialogDetail: false,
      childUid: '',
    },
    data() {
      return {
        loading: false,
        isShow: this.dialogDetail,
        tableData:[]
      }
    },
    watch: {
      dialogDetail() {
        this.isShow = this.dialogDetail;
      },
    },
    created() {
      this.query(this.childUid)
    },
    methods: {
      query(id){
        this.loading = true;
        getNotMergedSimilarChildList({childUid:id}).then(res=>{
          this.loading = false;
          this.tableData = res.responseData
        })
      },
      closeDetail(){
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dialog-content {
    width: 100%;
    background-color: #ffffff;

    .btn-view {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .btn {
        width: 4.063vw;
        height: 1.875vw;
        background: #E8556F;
        border-radius: 0.208vw;
        display: flex;
        align-items: center;
        justify-content: center;

        margin-right: 1.563vw;

        img {
          width: 0.781vw;
          height: 0.781vw;
          margin-right: 0.26vw;
        }

        span {
          font-size: 12px;
          font-family: PingFangSC;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }

    .dialog-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: #bfbfbf 0.052vw solid;
      height: 3.125vw;

      .order-no {
        font-size: 16px;
      }

      .status {
        display: flex;
        align-items: center;

        img {
          width: 0.781vw;
          height: 0.781vw;
          margin-right: 0.521vw;
        }

        span {
          font-size: 12px;
        }
      }
    }

    .screen {
      width: 100%;
      height: auto;
      min-height: 30%;

      .form {
        width: 100%;
      }

      .value-box {
        width: 9.375vw;
        font-size: 12px;
        height: 1.6vw;
        background-color: #f8f8f8;
        border: #d0d0d0 1px solid;
        line-height: 1.6vw;
        padding: 2px;
        border-radius: 2px;
      }

      .fj {
        display: flex;
        margin-top: 1.042vw;
        flex-direction: column;

        .fj-title {
          display: flex;
          align-items: center;
          height: 1.042vw;

          .shu {
            width: 0.104vw;
            height: 0.521vw;
            background-color: #dc243e;
          }

          span {
            font-size: 12px;
            margin-left: 0.26vw;
          }
        }

        .fj-name {

          margin-top: 0.521vw;
          font-size: 12px;
        }

        img {
          width: 6.25vw;
          height: 6.25vw;
          background-color: #666666;
          margin-top: 0.26vw;
        }
      }

      .form-line {
        display: flex;
        align-items: center;
        width: 100%;
        height: 3.125vw;

        .close-form {
          flex-shrink: 0;

          img {
            width: 0.625vw;
            height: 0.521vw;
          }

          span {
            font-size: 12px;
            font-family: PingFangSC;
            font-weight: bold;
            color: #999999;
          }
        }

        .photo {
          width: 8vw;
          height: 5vw;
          margin-right: 1vw;
          background-color: #666666;
        }

        .form-item {
          display: flex;
          margin-right: 2vw;
          align-items: center;
          position: relative;
          flex-shrink: 1;

          .error {
            position: absolute;
            display: flex;
            font-size: 12px;
            color: #dc243e;
            bottom: -1.302vw;
            align-items: center;

            img {
              width: 0.729vw;
              height: 0.729vw;
              margin-right: 0.26vw;
            }

            span {
              font-size: 0.625vw;
            }
          }

          .label {
            display: block;
            width: 4.167vw;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .value-box {
            width: 9.375vw;
            font-size: 12px;
            height: 1.6vw;
            background-color: #f8f8f8;
            border: #d0d0d0 1px solid;
            line-height: 1.6vw;
            padding: 2px;
            border-radius: 2px;
          }

          input {
            width: 9.375vw;
            font-size: 12px;
            height: 1.6vw;
            //border: none;
            //border-bottom: #B3B3B3 0.052vw solid;
            outline: none;
          }

          select {
            width: 9.375vw;
            font-size: 0.729vw;
            border: none;
            border-bottom: #B3B3B3 0.052vw solid;
            outline: none;
          }

          textarea {
            resize: none;
            outline: none;
            font-size: 12px;
          }

          /deep/ .el-upload--picture-card {
            width: 5.208vw;
            height: 5.208vw;
            line-height: 5.729vw
          }

          /deep/ .el-radio__label {
            font-size: 12px !important;
          }

          .radio-view {
            width: 9.375vw;
            margin-left: 0.5vw;
          }

          /deep/ .el-date-editor.el-input,
          .el-date-editor.el-input__inner {
            width: 5.208vw;

            input {
              font-size: 12px;
              height: 1.042vw;
              text-align: center;
              border: none;
              border-bottom: #B3B3B3 0.052vw solid;
              outline: none;
              padding: 0;
              border-radius: 0;
            }
          }

          /deep/ .el-input__prefix {
            display: none !important;
          }

          /deep/ .el-input__suffix {
            display: none !important;
          }
        }

        .btn {
          width: 4.063vw;
          height: 1.875vw;
          background: #E8556F;
          border-radius: 0.208vw;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-right: 1.563vw;

          img {
            width: 0.781vw;
            height: 0.781vw;
            margin-right: 0.26vw;
          }

          span {
            font-size: 12px;
            font-family: PingFangSC;
            font-weight: bold;
            color: #FFFFFF;
          }
        }

        .new {
          margin-left: 20vw;
          margin-right: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/child/audit/existsSimilarTable.vue